import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHousekeepingStatus.ts
var t = () => e("housekeepingStatus");
//#endregion
export { t as useTrHousekeepingStatus };
